import { useState } from "react";
import { IDX_URL } from "../lib/idxConfig";

export const SmartApartmentIdx = ({ title = "Search Live Houston Apartment Inventory" }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="rounded-2xl border border-slate-200 overflow-hidden bg-white shadow-sm" data-testid="idx-search-section">
      <div className="px-6 py-4 bg-[#0A2342] flex items-center justify-between">
        <h2 className="text-white font-bold text-base md:text-lg" data-testid="idx-search-title">{title}</h2>
        <span className="text-xs text-slate-400 hidden sm:block">Real-time pricing &amp; availability</span>
      </div>
      <div className="relative">
        {!loaded && (
          <div className="absolute inset-0 flex items-center justify-center bg-[#F8FAF7]" data-testid="idx-loading">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#0A2342]" />
          </div>
        )}
        <iframe
          src={IDX_URL}
          title={title}
          onLoad={() => setLoaded(true)}
          className="w-full border-0"
          style={{ height: "80vh", minHeight: 560 }}
          loading="lazy"
          data-testid="idx-iframe"
        />
      </div>
    </div>
  );
};

export default SmartApartmentIdx;
